module.exports = __webpack_public_path__ + "img/home.a2565e19.svg";